import React, { Component } from 'react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import { inject, observer } from "mobx-react"
import { Table } from "antd"
import { getCurrentApp } from "app/api/localTools"
import List from "app/stores/list"

@inject("auth") @observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.list = new List(this, `bio/version/${getCurrentApp()}`)
  }

  componentDidMount() {
    const { getTableData } = this.list
    getTableData()
      .then(
        res => {
          this.list.updateTableData(res)
          this.list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    this.list.changePagin(selectedPageNumber)
    document.getElementById("contentTop").scrollIntoView(true)
  }

  render() {
    const { onClose } = this.props
    const { tableData, totalCount, currentPageIndex, queryMap } = this.list
    const columns = [{
      title: "版本号",
      className: "ta-l",
      dataIndex: "version",
      width: 120,
    }, {
      title: "更新内容",
      className: "ta-l",
      dataIndex: "content",
    }, {
      title: "创建时间",
      className: "ta-l",
      dataIndex: "createTime",
      width: 180,
    }, {
      title: "是否最新",
      className: "ta-l",
      dataIndex: "latest",
      width: 120,
      render: (text) => {
        return (
          text ? '是' : '否'
        )
      }
    }]
    return (
      <MaterialModal
        title={`生信${getCurrentApp().toUpperCase()}版本更新记录`}
        visible
        width={1000}
        footer={false}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Table
          className="bioVersionTable"
          columns={columns}
          rowKey={record => record.id}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BioVersionListModal/index.js